import { Sun, Moon } from 'lucide-react'
import { useTheme } from '@/contexts/ThemeContext'

export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme()

  return (
    <button
      onClick={toggleTheme}
      className="theme-btn bg-btn-bg border border-primary text-primary px-2.5 py-2 rounded-lg cursor-pointer transition-all duration-300 hover:bg-primary hover:text-background"
      title={theme === 'dark' ? 'Modo Claro' : 'Modo Oscuro'}
      aria-label={theme === 'dark' ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'}
    >
      {theme === 'dark' ? (
        // Icono de sol (modo claro disponible)
        <Sun className="w-4 h-4" />
      ) : (
        // Icono de luna (modo oscuro disponible)
        <Moon className="w-4 h-4" />
      )}
    </button>
  )
}
